// Types now live in core-fe-lib. Re-exported here so existing imports keep working.
export type { GlobalConfigSchemaEntry } from "core-fe-lib/components-shadcn/composables/configSchemaTypes";

import type { GlobalConfigSchemaEntry } from "core-fe-lib/components-shadcn/composables/configSchemaTypes";

export const GLOBAL_CONFIG_SCHEMA: GlobalConfigSchemaEntry[] = [
  // ── AI / Embeddings ───────────────────────────────────────────────────────
  {
    key: "OLLAMA_SERVER_IP",
    label: "Ollama Server IP",
    description:
      "IP address (or host:port) of the Ollama server used for local embedding generation. Example: 192.168.1.10:11434",
    type: "text",
    category: "AI / Embeddings",
  },
  {
    key: "OPENAI_API_KEY",
    label: "OpenAI API Key",
    description: "API key for OpenAI services (GPT-4o, embeddings, etc.).",
    type: "text",
    category: "AI / Embeddings",
  },
  {
    key: "ANTHROPIC_API_KEY",
    label: "Anthropic API Key",
    description: "API key for Anthropic Claude models.",
    type: "text",
    category: "AI / Embeddings",
  },
  {
    key: "GOOGLEAI_API_KEY",
    label: "Google AI API Key",
    description: "API key for Google AI (Gemini) models.",
    type: "text",
    category: "AI / Embeddings",
  },
  {
    key: "SCALEWAY_API_KEY",
    label: "Scaleway API Key",
    description: "API key for Scaleway AI inference endpoints.",
    type: "text",
    category: "AI / Embeddings",
  },
  {
    key: "OVH_API_KEY",
    label: "OVH API Key",
    description: "API key for OVH AI Endpoints.",
    type: "text",
    category: "AI / Embeddings",
  },
  {
    key: "MISTRAL_API_KEY",
    label: "Mistral API Key",
    description: "API key for Mistral AI models.",
    type: "text",
    category: "AI / Embeddings",
  },
];

/** O(1) lookup by key */
export const GLOBAL_SCHEMA_MAP = new Map<string, GlobalConfigSchemaEntry>(
  GLOBAL_CONFIG_SCHEMA.map((e) => [e.key, e])
);

/** Ordered list of unique category names */
export const GLOBAL_SCHEMA_CATEGORIES = [
  ...new Set(GLOBAL_CONFIG_SCHEMA.map((e) => e.category)),
];

export function getGlobalSchemaEntry(
  key: string
): GlobalConfigSchemaEntry | undefined {
  return GLOBAL_SCHEMA_MAP.get(key);
}
